import React from 'react'
import TermsContent from './TermsContent'
import CloseIconBasic from '../elements/CloseIconBasic'

export default function TermsAndConditions({ onCancel }: any): JSX.Element {
    return (
        <div className="container position-relative p-lg-20 p-md-15 p-sm-10 p-5" style={{ height: '100%' }}>
            <CloseIconBasic onCancel={onCancel} />
            <TermsContent />

        </div>
    )
}
